/*
Copyright© Celligence International, LLC - 2024
This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { EscrowPaymentScheduleProvider } from '../contexts/EscrowPaymentScheduleContext';
import { memo } from 'react';
import EscrowPaymentForm from '../components/forms/EscrowPaymentForm';
import { SnackbarProvider } from 'notistack';

const LoginPage = () => {
  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={2500}
      preventDuplicate
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <EscrowPaymentScheduleProvider>
        <EscrowPaymentForm />
      </EscrowPaymentScheduleProvider>
    </SnackbarProvider>
  );
};

export default memo(LoginPage);
